import { plainToClass } from "class-transformer";
import { JsonItem, AppUserRedacted, PickListItem } from "../../../../secure/list-management/scripts/list-management.objects";

declare var $: any;
export class UserOrganizationPage {
    currentAppUser: AppUserRedacted;
    initialOrganizations: string[] = [];
    organizationSelect: JQuery<HTMLElement>;
    pickLists: JsonItem[];

    constructor(entity: any, pickLists: any) {
        $(() => {
            this.currentAppUser = plainToClass(AppUserRedacted, <AppUserRedacted>entity);
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);
            this.organizationSelect = $("#organization-dropdown");
            if (this.currentAppUser.OrganizationIds) {
                this.initialOrganizations = this.currentAppUser.OrganizationIds.split("|");
            }
            else {
                this.initialOrganizations = [];
            }

            this.initializeDropdown();
        });
    }

    initializeDropdown(): void {
        let orgPickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-organization-names").Json;
        let orgOptions: string[][] = [];
        orgPickList.forEach(item => {
            orgOptions.push([item.Id.toString(), item.Value]);
        })

        this.organizationSelect.selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {
                if (numSelected == numTotal) {
                    return "All";
                }
                else {
                    return numSelected + " Selected";
                }
            }
        });

        orgOptions.sort((x1: string[], x2: string[]) => x1[1].localeCompare(x2[1]));
        orgOptions.forEach((element: any[]) => {
            let selected = false;
            let optionId = element[0];
            if (this.initialOrganizations.includes(optionId)) {
                selected = true;
            }
            this.organizationSelect.append(new Option(element[1], element[0], false, selected));
        });

        this.organizationSelect.selectpicker("refresh");
    }

    async updateOrganizations(): Promise<any> {
        // Show Saving
        let successModal = $("#success-modal");
        successModal.find("#saving-content").removeClass("d-none");
        successModal.find("#success-content").addClass("d-none");
        successModal.find(".modal-header").addClass("d-none");
        successModal.modal("show");

        let result = await this.saveOrganizations();

        // Show Saved
        successModal.find("#saving-content").addClass("d-none");
        successModal.find("#success-content").removeClass("d-none");
        successModal.find(".modal-header").removeClass("d-none");  
    }

    async saveOrganizations(): Promise<any> {
        let selectedOptions = this.organizationSelect.val();
        let updatedOrgs = "";
        if (selectedOptions) {
            let selectedArr = <string[]>selectedOptions;
            updatedOrgs = selectedArr.join("|");
        }

        this.currentAppUser.OrganizationIds = updatedOrgs;
        let updatedUser: AppUserRedacted = this.currentAppUser;

        let result: Promise<any>;
        try {
            result = await $.ajax({
                url: `/auth/pages/profile/user-organization?handler=SaveOrganization`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(updatedUser) },
            })
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}